import { EnvMode } from "./EnvMode";

export const environment = {
  mode: EnvMode.STAGING,
  apiUrl: '/api',
  trackerUrl: '/matomo',
  siteId: '1'
};
